import React, { useContext, useState } from "react";
import FuncionesContext from "../../../context/FuncionesContext";
import VistaContext from "../../context/VistaContext";
import { getAtributo } from "../../../context/FuncionesContext";

const Boton = ({
  data,
  cab,
  hijos,
  campokey,
  indiceData,
  id_elemento,
  context = VistaContext,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [procesando, setProcesando] = useState(false);

  const f = useContext(FuncionesContext);
  const bctx = useContext(context);

  const {
    boton_padding = "0.2rem 0.5rem",
    boton_backgroundColor = "rgba(212, 215, 217, 1)",
    boton_textAlign = "center",
    boton_cursor = "pointer",
    boton_width = "100px",
    boton_borderRadius = "15px",
    boton_image_height = "40px",
    boton_image_alt = "imagen",
    boton_color = "black"
  } = cab;

  const boton_texto = getAtributo("boton_texto", data, cab) ?? "Click Aqui!"

  const botonStyle = {
    padding: boton_padding,
    backgroundColor: boton_backgroundColor,
    textAlign: boton_textAlign,
    cursor: boton_cursor,
    width: boton_width,
    borderRadius: boton_borderRadius,
    color: boton_color,
  };

  const handleCancelar = () => console.log("Cancelado");
  const handleClick = async () => {
    try {
      let funcion = "";

      setIsClicked(true);
      setProcesando(true);
      setTimeout(() => {
        setIsClicked(false);
      }, 300);
      if (cab.funcion_back && cab.funcion_back.trim() !== "") {
        // vista boton siempre tiene funcion endpoint desde el Switch
        const botonendpoint = `/vistaBoton/` + cab.id_a;
        funcion = "endpoint";
        cab = Object.assign({
          ...cab,
          endpoint: botonendpoint,
          boton_funcion_onClick: cab.boton_funcion_onClick ?? funcion,
        });
      }
      if (cab.boton_funcion_onClick) {
        funcion = cab.boton_funcion_onClick;
      }
      if (cab.boton_funcion_alias) {
        funcion = data[cab.boton_funcion_onClick_alias];
      }

      const res = await f[funcion]({
        data,
        cab,
        indiceData,
        handleCancelar,
        context: bctx,
        callback: (r) => setProcesando(false),
      });

      if (res && res.status < 400 && cab.cerrar_modal === "s") {
        const modal = bctx?.modalProps;
        if (modal?.esModal && modal?.open) {
          modal.cerrar();
        }
      }

      return setProcesando(false);
    } catch (err) {
      console.error("Error en el botón:", err);
      return setProcesando(false);
    }
  };

  const className = getAtributo("className", data, cab);
  const iconClassName = getAtributo("icon_className", data, cab);
  const disabled = getAtributo("disabled", data, cab) === "s";
  const sin_acceso = getAtributo("condicion_acceso", data, cab);
  
  if (sin_acceso==='n') return <></>;
  return (
    <div
      id={id_elemento}
      style={{ width: "100%", gridColumn: cab.grid_span, margin: cab.margin }}
    >
      <div
        style={{
          gridColumn: cab.grid_span,
          width: cab.width,
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? "none" : "auto", // evita click
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        onClick={disabled || procesando ? () => {} : handleClick}
        className={`btn-orixia ${isClicked ? "clicked" : ""} ${className} ${
          disabled ? "disabled" : ""
        }`}
      >
        {cab.imagen_url ? (
          <img
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
            height={boton_image_height}
            src={cab.imagen_url}
            alt={boton_image_alt}
          />
        ) : (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "6px",
            }}
          >
            {iconClassName && <i className={iconClassName}></i>}

            <span>
              {boton_texto}
            </span>
          </div>
        )}
      </div>
      {/* {hijos} */}
    </div>
  );
};

export default Boton;
